import { Fragment, PropsWithChildren } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { ExclamationCircleIcon, XIcon } from '@heroicons/react/outline';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
}

export function InfoModal({
  isOpen,
  onClose,
  children,
  title,
}: PropsWithChildren<ModalProps>) {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-[99] overflow-y-auto"
        onClose={onClose}
      >
        <Dialog.Overlay className="fixed inset-0" />
        <div className="bg-black px-4 text-center">
          <span
            className="inline-block h-screen align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="inline-block w-full max-w-2xl transform overflow-hidden rounded-lg bg-neutral-900 p-5 text-left align-middle shadow-xl transition-all sm:p-6 sm:align-middle">
              <header className="flex items-center justify-between">
                {title?.length > 0 ? (
                  <Dialog.Title
                    as="h3"
                    className="flex items-center text-lg leading-6 text-white"
                  >
                    <ExclamationCircleIcon className="mr-2 h-6 w-6 text-white" />
                    {title}
                  </Dialog.Title>
                ) : (
                  <span> </span>
                )}
                <button type="button" onClick={onClose}>
                  <span className="sr-only">Close</span>
                  <XIcon className="h-6 w-6 text-white" aria-hidden="true" />
                </button>
              </header>

              <div className="mt-8 space-y-4 text-white">{children}</div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}

export default InfoModal;
